import React, { useState, forwardRef, useRef, useImperativeHandle } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { ReactComponent as LeftCircleIcon } from "../../assets/svgs/left-circle.svg";
import { ReactComponent as RightCircleIcon } from "../../assets/svgs/right-circle.svg";
import ButtonBase from "@mui/material/ButtonBase";
import Box from "@mui/material/Box";

import "./style.css";

export const ImageSlider = forwardRef((props, ref) => {
    const { images, sx, setting = {}, autoPlay, isMobile } = props;
    const [slider, setSlider] = React.useState();
    const settings = {
        dots: false,
        fade: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplaySpeed: 1500,
        arrows: false,
        ...setting,
    };

    useImperativeHandle(ref, () => ({
        start() {
            slider?.slickPlay();
        },

        stop() {
            slider?.slickPause();
        },
    }));

    const renderArrows = () => {
        return (
            <div className="slider-arrow">
                <ButtonBase
                    className="arrow-btn prev"
                    onClick={(event) => {
                        event.stopPropagation();
                        slider.slickPrev();
                    }}
                >
                    <LeftCircleIcon style={{ width: "20px", height: "20px" }} />
                </ButtonBase>
                <ButtonBase
                    className="arrow-btn next"
                    onClick={(event) => {
                        event.stopPropagation();
                        slider.slickNext();
                    }}
                >
                    <RightCircleIcon style={{ width: "20px", height: "20px" }} />
                </ButtonBase>
            </div>
        );
    };

    return (
        <Box
            sx={
                isMobile
                    ? {
                          position: "relative",
                          display: { xs: "flex", sm: "block" },
                          alignItems: "center",
                          height: { xs: "calc(100vh - 200px)", sm: "auto" },
                      }
                    : {
                          position: "relative",
                      }
            }
        >
            {renderArrows()}
            <Slider
                {...settings}
                ref={(slider) => {
                    setSlider(slider);
                    if (props.onLoadComplete) {
                        props.onLoadComplete(slider);
                    }
                }}
            >
                {images.map((item) => (
                    <div className="test" key={item.id} style={{ display: "flex", alignItems: "center" }}>
                        {item.type?.startsWith("image") && (
                            <img
                                style={{ ...sx }}
                                src={item.url} //{"https://dftv8f1fk2r9j.cloudfront.net/" + item.fileId}
                                alt={item.alt}
                            />
                        )}
                        {item.type?.startsWith("video") && (
                            <video
                                style={{ ...sx }}
                                controls={autoPlay ? true : false}
                                autoPlay={autoPlay ? true : false}
                                muted
                            >
                                <source src={item.url} type="video/mp4" />
                            </video>
                        )}
                    </div>
                ))}
            </Slider>
        </Box>
    );
});
